import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { take } from 'rxjs/operators';
import { LS } from 'src/app/helpers/localStorage.enum';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DataService } from 'src/app/services/data/data.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-menu-list',
  templateUrl: './menu-list.component.html',
  styleUrls: ['./menu-list.component.sass'],
})
export class MenuListComponent implements OnInit {
  @Input() notifications = [];
  currentUser;
  permissions: any;

  isSuperAdmin = false;

  get isSuntory() {
    return location?.hostname.includes('suntory');
  }

  get version() {
    const { version } = require('../../../../../package.json');
    return version;
  }
  constructor(
    private translateService: TranslateService,
    private authService: AuthService,
    private router: Router,
    private readonly spinner: NgxSpinnerService,
    private dataService: DataService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.dataService.localStorageSub$.subscribe((res) => {
      if (res.key === LS.currentUser) {
        this.currentUser = JSON.parse(res.data);
        this.permissions = this.currentUser.permissions;
      } else {
        this.currentUser = JSON.parse(localStorage.getItem(LS.currentUser));
        this.permissions = this.currentUser.permissions;
      }
      this.isSuperAdmin = this.currentUser.roles.includes('SuperAdmin');
    });
  }

  openLangSettings() {
    this.router.navigate(['/dashboard/settings/languages']);
  }

  useLanguage(language: string) {
    this.translateService.use(language);

    const pref = {};
    pref[LS.defaultLang] = language;
    this.userService
      .update(this.currentUser.user_id, { preferences: pref }, false)
      .toPromise()
      .then((res) => {
        this.dataService.setLocalStorage(LS.defaultLang, language);
      });
    // this.userService.setPreference(this.currentUser.user_id, LS.defaultLang, language).pipe(take(1)).subscribe(res => {
    //   // localStorage.setItem(LS.defaultLang, language)
    //   this.dataService.setLocalStorage(LS.defaultLang, language)
    // })
  }

  logout() {
    this.spinner.show();

    this.authService.logout().subscribe(
      (res) => {
        try {
          this.dataService.clearDataService();
        } catch (err) {
          console.error('Error with clearing data service.Err: ', err);
        }

        /** Retains cache lang after logging out for consistency */
        const cache = localStorage.getItem(LS.defaultLang),
          host = localStorage.getItem(LS.host);

        localStorage.clear();

        if (cache) this.dataService.setLocalStorage(LS.defaultLang, cache);
        if (host) this.dataService.setLocalStorage(LS.host, host);

        this.spinner.hide();

        this.goToLogin();
      },
      ({ error }) => {
        this.spinner.hide();

        this.goToLogin();
      }
    );
  }

  async goToLogin() {
    try {
      await this.router.navigate(['/login']);
    } catch (err) {
      console.error('Error while navigating. Err: ', err);
    } finally {
      this.router.navigate(['/login']);
      location.reload();
    }
    // this.router.navigate(['/login']).then(() => {
    //   /** Refreshes the page to reset all subscriptions and listeners */
    //   location.reload()
    // }, (err) => {
    //   console.error('Error with navigating to login.Err: ', err)
    //   location.reload()
    // });
  }

  redirectToProfile() {
    this.router.navigate(['/profile']);
  }

  redirectToNotification() {
    this.router.navigate(['/notifications']);
  }
}
